import { Component, OnInit } from "@angular/core";
@Component({
  standalone: false,
  selector: "app-coming-soon",
  templateUrl: "./coming-soon.component.html",
  styleUrls: ["./coming-soon.component.css"],
})
export class ComingSoonComponent implements OnInit {
  iconClock = 'schedule';
  constructor() {}
  ngOnInit(): void {}
}
